<template>
  <div class="app-shell">
    <div
      :class="[
        'app-shell__page',
        { 'app-shell__page--footer-gap': shouldAddFooterGap },
      ]"
      data-testid="app-page-content"
    >
      <RouterView />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const footerGapRouteNames = new Set([
  'film-detail',
  'film-section',
  'person-detail',
  'person-section',
  'show-section',
  'home',
  'home-content',
  'home-films',
  'public-profile',
  'demo-profile',
  'film-list-detail',
  'film-list-section',
  'show-list-detail',
  'show-list-section',
  'episode-list-detail',
  'episode-list-section',
  'person-list-detail',
  'person-list-section',
  'search',
  'discover',
  'terms-of-service',
  'privacy-policy',
  'cookie-policy',
  'contact-information',
])
const route = useRoute()
const shouldAddFooterGap = computed(() => footerGapRouteNames.has(route.name))
</script>

<style scoped>
.app-shell {
  min-height: 100vh;
}

.app-shell__page--footer-gap {
  padding-bottom: 4rem;
  background: #001019;
}
</style>
